import { ls } from 'services';

const NUTTREMA_PROFESSIONAL_CURRENT_THEME = 'NUTTREMA_PROFESSIONAL_CURRENT_THEME';
const NUTTREMA_PROFESSIONAL_DEFAULT_THEME = 'theme-professional-topography';

const THEME_PROFESSIONAL_LIST = [
  {
    name: 'label.turquoise',
    code: 'theme-professional-turquoise',
  },
  {
    name: 'label.topography',
    code: 'theme-professional-topography',
  },
];

const ThemeManager = {
  changeTheme(theme) {
    ls.set(NUTTREMA_PROFESSIONAL_CURRENT_THEME, theme);
    const body = document.querySelector('body');
    body.className = `nuttrema-${theme}`;
  },
  getCurrentTheme() {
    return ls.get(NUTTREMA_PROFESSIONAL_CURRENT_THEME, NUTTREMA_PROFESSIONAL_DEFAULT_THEME);
  },
  listThemes() {
    return THEME_PROFESSIONAL_LIST;
  },
  init() {
    const current = this.getCurrentTheme(NUTTREMA_PROFESSIONAL_DEFAULT_THEME);
    const body = document.querySelector('body');
    body.className = `nuttrema-${current}`;
  },
};

export { ThemeManager };



// WEBPACK FOOTER //
// ./src/services/theme-manager.js